module.exports = __webpack_public_path__ + "static/media/facebook_messenger.cc555192.svg";